export default "__VITE_ASSET__BB3LySN5__"